import axios from "axios";
import Config from "../../../config";

const v2_actionDeletarNotaLead = (noteId) => {
    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/leads/notes/${noteId}/delete`
    });
};

export default v2_actionDeletarNotaLead;
